import type { PatientStrings } from '../index';

export const te: PatientStrings = {
  titleOne: 'మీ కొత్త క్రౌన్',
  titleMany: 'మీ కొత్త క్రౌన్‌లు',
  tooth: 'పన్ను',
  teeth: 'పళ్లు',
  both: 'రెండూ',
  overview: 'మొత్తం దృశ్యం',
  front: 'ముందు నుండి',
  leftSide: 'ఎడమ వైపు',
  rightSide: 'కుడి వైపు',
  bitingSurface: 'నమిలే ఉపరితలం',
  show: 'చూపించు',
  newCrown: 'కొత్త క్రౌన్',
  newCrowns: 'కొత్త క్రౌన్‌లు',
  yourTeeth: 'మీ పళ్లు మరియు చిగుళ్లు',
  upperTeeth: 'పై పళ్లు',
  lowerTeeth: 'కింది పళ్లు',
  hint: 'తిప్పడానికి లాగండి · జూమ్ చేయడానికి పించ్ లేదా స్క్రోల్ చేయండి',
  zoomIn: 'దగ్గరగా',
  zoomOut: 'దూరంగా',
  turnSlowly: 'నెమ్మదిగా తిప్పు',
  stopTurning: 'తిప్పడం ఆపు',
  backToStart: 'మొదటికి',
  fullScreen: 'పూర్తి స్క్రీన్',
  exitFullScreen: 'పూర్తి స్క్రీన్ నుండి బయటకు',
  fromDentist: 'మీ దంత వైద్యుల నుండి',
  shadeNote: (shade) =>
    `రంగు సుమారుగా షేడ్ ${shade} లాగా చూపబడింది. అసలు క్రౌన్ రంగును ల్యాబ్‌లో సరిపోలుస్తారు.`,
  before: 'ముందు',
  after: 'తర్వాత',
  seeInRoom: 'మీ గదిలో చూడండి',
  arNotSupported: 'క్రౌన్‌ను మీ గదిలో చూడటానికి ఈ పేజీని మీ ఫోన్‌లో తెరవండి.',
  appointmentTitle: 'క్రౌన్ అమర్చే మీ అపాయింట్‌మెంట్',
  confirm: 'నిర్ధారించండి',
  confirmed: 'నిర్ధారించబడింది — అప్పుడు కలుద్దాం',
  anotherTime: 'వేరే సమయం అడగండి',
  anotherTimeSent: 'మీకు వేరే సమయం కావాలని మీ దంత వైద్యులకు తెలియజేశాము.',
  language: 'భాష',
  largerText: 'పెద్ద అక్షరాలు',
};
